module.exports = __webpack_public_path__ + "img/1468708125.6b7e92d8.jpg";